import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Broadcast} from "../../../model/broadcast/broadcast";
import {BroadcastsService} from "../../../services/broadcasts.service";
import {UtilService} from "../../../services/util.service";
import {ControlAction} from "../../../model/broadcast/control";
import {Subscription} from "rxjs";
import {GamesService} from "../../../services/games.service";
import {Game} from "../../../model/broadcast/game";
import {BroadcastGamePair} from "../../../model/broadcast-game-pair";
import {LeaguesService} from "../../../services/leagues.service";
import {take} from "rxjs/operators";
import {StatusComponent} from "../status/status.component";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-followed-games',
  templateUrl: './followed-games.component.html',
  styleUrls: ['./followed-games.component.scss'],
  imports: [
    StatusComponent,
    NgForOf
  ],
  standalone: true
})
export class FollowedGamesComponent implements OnInit, OnDestroy {

  @Input() broadcast: Broadcast;
  @Input() controlAction: ControlAction;
  @Input() game: Game;

  public relatedBroadcasts: BroadcastGamePair[];
  private subscription: Subscription;

  constructor(
    public gamesService: GamesService,
    public leagueService: LeaguesService,
    public utilService: UtilService,
  ) { }

  ngOnInit(): void {
    if (!this.broadcast?.gameId) {
      return;
    }
    if (!this.game?.lastUpdate) {
      return;
    }

    const morningDate = this.game.lastUpdate.toDate();
    morningDate.setHours(0, 0, 0, 0);
    const midnightDate = this.game.lastUpdate.toDate();
    midnightDate.setHours(23, 59, 59, 999);

    this.leagueService.getLeague(this.broadcast.leagueId).pipe(take(1)).subscribe(league => {
      this.subscription = this.gamesService.getTournamentGames(this.broadcast.leagueId).subscribe(games => {
        //const relatedGames = games.filter(g => g.lastUpdate.toMillis() > morningDate.getTime()
        //  && g.lastUpdate.toMillis() < midnightDate.getTime()
        //  && g.gameId != this.game.gameId).sort((a,b) => a?.lastUpdate.toMillis() - b?.lastUpdate.toMillis());

        const relatedGames = games.filter(g =>
          Math.abs(g.lastUpdate.toMillis() - this.game.lastUpdate.toMillis()) < 1000*60*60 //one hour
          && g.gameId != this.game.gameId)
          .sort((a,b) => a?.lastUpdate.toMillis() - b?.lastUpdate.toMillis());
        this.relatedBroadcasts = relatedGames.map(g => {
          return {
            broadcast: {
              config: {
                homeConfig: league.teams.find(t => t.id == g.home.guid),
                awayConfig: league.teams.find(t => t.id == g.away.guid),
              },
            },
            game: g,
          }
        });

        this.relatedBroadcasts.sort((a,b) => a?.game?.firstUpdate?.toMillis() - b?.game?.firstUpdate?.toMillis());
        this.relatedBroadcasts.reverse();
      });
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
